import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Tile, Link } from '@paypalcorp/pp-react';
import Illustration from '../buttons/components/illustration/Illustration';
import PropTypes from 'prop-types';
import { checkKeyPressed } from '../utility/accessibilityUtils';

const styles = StyleSheet.create({
  tile: {
    padding: '0px 0px 0px 0px',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '6px',
    marginLeft: '5%',
  },
  image: {
    width: '50px',
  },
  description: {
    marginLeft: '3%',
  },
  text: {
    marginTop: '0px',
    marginBottom: '0px',
  },
  link: {
    cursor: 'pointer',
  },
});

class ReengagementTile extends Component {
  render() {
    return (
      <Tile
        data-testid="reengagement-tiles"
        className={`reengagement-tile ${css(styles.tile)}`}
      >
        <Tile.Content
          className={`reengagement-tile-container ${css(styles.container)}`}
        >
          <Illustration
            type={this.props.type}
            size={'small'}
            className={`reengagement-tile-image ${css(styles.image)}`}
            ariaHidden={true}
          />
          <div className={`reengagement-tile-value ${css(styles.description)}`}>
            <p className={`reengagement-tile-message ${css(styles.text)}`}>
              {this.props.description}
            </p>
            <Link
              className={`reengagement-tile-link ${css(styles.link)}`}
              onClick={this.props.clickEvent}
              data-testid="reengagement-tile-link"
              tabIndex="0"
              onKeyDown={(e) => checkKeyPressed(e, this.props.clickEvent)}
            >
              {this.props.descriptionLink}
            </Link>
          </div>
        </Tile.Content>
      </Tile>
    );
  }
}

ReengagementTile.propTypes = {
  clickEvent: PropTypes.func,
  description: PropTypes.string,
  type: PropTypes.string,
  descriptionLink: PropTypes.string,
};
export default ReengagementTile;
